var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgReportClone = function SvgReportClone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#90A8BF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.212 2.862h-1.81v-1.37c0-.824-.667-1.491-1.49-1.492h-9.42C.67 0 0 .669 0 1.491v12.16c.001.822.67 1.49 1.492 1.49h1.809v1.369c0 .823.669 1.49 1.492 1.49h9.42c.823 0 1.49-.667 1.491-1.49V4.353a1.495 1.495 0 0 0-1.492-1.491ZM3.3 4.353v9.65H1.492a.353.353 0 0 1-.353-.352V1.491c0-.194.159-.352.353-.352h9.42c.195 0 .352.158.352.352v1.371h-6.47c-.825 0-1.493.667-1.493 1.491ZM14.564 16.51c0 .193-.159.35-.352.35h-9.42a.353.353 0 0 1-.353-.35V4.353c0-.194.158-.352.353-.352h9.42c.194 0 .351.158.352.352V16.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.236 7.715a.57.57 0 0 0 .604.967 2.07 2.07 0 0 1 2.847.649c.293.467.387 1.02.263 1.557-.12.535-.449.998-.913 1.288a2.064 2.064 0 0 1-2.8-.59l.564.118a.57.57 0 0 0 .234-1.115l-2.433-.512-.509 2.396a.57.57 0 0 0 1.114.237l.1-.476a3.189 3.189 0 0 0 4.333.908 3.176 3.176 0 0 0 1.42-2 3.19 3.19 0 0 0-.41-2.416 3.208 3.208 0 0 0-4.414-1.01Z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReportClone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/report-clone.b51c8ce9.svg";
export { ForwardRef as ReactComponent };